import React from 'react';
import { IconCheckmark16, IconCalendar16 } from '@dhis2/ui';
import './checkInComponents.css';

const ManagerReviewPanel = ({
  checkInData,
  onSaveReview,
  onScheduleMeeting,
  onUpdateCheckIn,
  isSaving,
  isReadOnly = false,   // true → review is completed; lock fields + "Complete Review" button
}) => {
  return (
    <div>
      <h3 className="cc-summary-title">Manager Review</h3>

      {/* Informational banner when the review is already completed */}
      {isReadOnly && (
        <div
          style={{
            padding: '10px 12px',
            marginBottom: '16px',
            backgroundColor: '#ecfdf5',
            border: '1px solid #a7f3d0',
            borderRadius: 8,
            color: '#065f46',
            fontSize: '0.85rem',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <IconCheckmark16 /> This review is completed. You can still schedule or reschedule a meeting if needed.
        </div>
      )}

      <div className="cc-field">
        <label className="cc-label">Review Comments</label>
        <textarea
          className="cc-textarea"
          placeholder="Share your overall feedback for this check-in..."
          value={checkInData.managerReviewComments || ''}
          disabled={isReadOnly}                            /* ✅ LOCK when review completed */
          onChange={(e) =>
            onUpdateCheckIn(prev => ({ ...prev, managerReviewComments: e.target.value }))
          }
        />
      </div>

      <div className="cc-field" style={{ marginBottom: 0 }}>
        <label className="cc-label">Next Steps / Action Items</label>
        <textarea
          className="cc-textarea"
          placeholder="Define agreed action items..."
          value={checkInData.managerReviewNextSteps || ''}
          disabled={isReadOnly}                            /*  LOCK when review completed */
          onChange={(e) =>
            onUpdateCheckIn(prev => ({ ...prev, managerReviewNextSteps: e.target.value }))
          }
        />
      </div>

      <div className="cc-stack">
        {/* Schedule Meeting — ALWAYS enabled so manager can reschedule */}
        <button
          type="button"
          className="cif-btn cif-btn--indigo cif-btn--block"
          onClick={onScheduleMeeting}
          disabled={isSaving}                              /* only blocks during an in-flight save */
        >
          <IconCalendar16 /> {checkInData.meetingDate ? 'Reschedule Meeting' : 'Schedule Meeting'}
        </button>

        {/* Complete Review — DISABLED once the review is completed */}
        <button
          type="button"
          className="cif-btn cif-btn--success cif-btn--block"
          disabled={isSaving || isReadOnly}                 /*  DISABLE when locked */
          onClick={onSaveReview}
          title={isReadOnly ? 'Review already completed' : 'Complete this check-in review'}
        >
          <IconCheckmark16 />
          {isSaving ? 'Saving...' : (isReadOnly ? 'Review Completed' : 'Complete Review')}
        </button>
      </div>
    </div>
  );
};

export default ManagerReviewPanel;